/**
 * Inclusive span between anchor and target in DISPLAYED order (post-filter,
 * post-sort), unioned with the existing selection. Using display order is the
 * point — a shift-click that selected a span of the underlying session order
 * would appear to select unrelated rows.
 */
export function rangeSelect(selected: string[], orderedNames: string[], anchor: string, target: string): string[] {
  const a = orderedNames.indexOf(anchor);
  const b = orderedNames.indexOf(target);
  if (a === -1 || b === -1) return selected.slice();
  const span = orderedNames.slice(Math.min(a, b), Math.max(a, b) + 1);
  return Array.from(new Set([...selected, ...span]));
}
